import { render, staticRenderFns } from "./Affiliation.vue?vue&type=template&id=73816803"
import script from "./Affiliation.vue?vue&type=script&lang=js"
export * from "./Affiliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports